/* eslint-disable react/no-array-index-key */
import { SelectableOptionButton } from "../SelectableOptionButton/SelectableOptionButton";
import { JText } from "../Text/Text";

export type SelectableListProps = {
  options?: {
    value: string | boolean | number;
    label: string;
  }[];
  value?: string | string[] | boolean | number | undefined;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  className?: string;
  elementsClassName?: string;
  disabled?: boolean;
  editable?: boolean;
};

export function SelectableOptionsList(props: SelectableListProps) {
  return (
    <div>
      {Array.isArray(props.value) && (
        <JText labelKey="common.multipleSelection" />
      )}

      <div
        className={
          props.className || "flex mt-2 flex-wrap justify-center gap-2"
        }
      >
        {props.options?.map((option, index) => {
          return (
            <SelectableOptionButton
              value={props.value}
              option={option}
              onChange={props.onChange}
              key={index}
              className={props.elementsClassName}
              disabled={props.disabled}
              editable={props.editable}
            />
          );
        })}
      </div>
    </div>
  );
}
